import Vue from 'vue';
import HomeAPI from '../api/index';
import _ from 'lodash';

export default function createModule() {
    let serverApi = {
        baseView: 'getHomeBaseData',
        seoInfo: 'getHomeSeoInfo',
        esf_recommend: 'getHomePropSaleList',
        xf_themeList: 'getHomePropXfTheme',
        xf_recommend: 'getHomePropXfList',
        hot_questionsList: 'getHomeHotQuestion',
        get_ashen_switch: 'getAshenSwitch',
        get_home_m_base_data: 'getHomeMBaseData'
    };

    // 接口默认数据
    const DEFAULT_DATA = {
        baseView: {
            is_redirct_xf: 0,
            seo_source_type: 0,
            menu: [],
            top_menu: [],
            tool: [],
            toutiao: {
                list: []
            }
        },
        seoInfo: [],
        esf_recommend: {
            total: 0,
            page: 0,
            has_more: '0',
            list: []
        },
        xf_themeList: {
            theme_packs: []
        },
        xf_recommend: {
            total: 0,
            rows: []
        },
        hot_questionsList: {
            list: []
        },
        get_ashen_switch: {
            is_open: false
        },
        get_home_m_base_data: {
            top_menu: [],
            icons: [],
            card_list: []
        }
    };

    let clientApi = {};

    let stateToApi = _.merge({}, serverApi, clientApi);

    let getters = {};
    Object.keys(stateToApi).forEach((value, index) => {
        getters[value] = state => state[value];
    });

    return {
        moduleName: 'homeModule',
        moduleEntity: {
            namespaced: true,
            state: () => ({
                baseView: {},
                saleList: {},
                xfTheme: {},
                xfList: {},
                recommend: {},
                hotQuestions: {},
                hotTags: {},
                hotCommunity: {},
                xfHotTag: {},
                xfHotSearch: {},
                seoDescription: ''
            }),
            mutations: {
                SET_DATA: (state, { key, data }) => {
                    Vue.set(state, key, data);
                },
                SET_SEO_DESCRIPTION(state, value) {
                    state.seoDescription = value;
                }
            },
            actions: {
                GET_STATE_DATA: ({ commit }, { key, params }) => {
                    const apiName = stateToApi[key];
                    return HomeAPI[apiName](params)
                        .then(data => {
                            commit('SET_DATA', { key, data });
                        })
                        .catch(error => {
                            console.log(`${new Date().toISOString()} 首页接口异常: ${apiName}`, error);
                            const defaultData = DEFAULT_DATA[key] || {};
                            commit('SET_DATA', { key, data: defaultData });
                        });
                }
            },
            getters
        },
        serverApi,
        clientApi,
        stateToApi
    };
}
